import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import PlacementTestItemListService from './PlacementTestItemListService';

class CreatePlacementItemDraftService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      placementTestId: null,
      item: null,
      grammarPlacementTestLevel: null,
    });
    this.form.validations = {
      draftCreationReason: [isRequired],
    };
  }

  init = action((placementTestId) => {
    this.form.reset();
    this.isOpen = false;
    this.item = null;
    this.placementTestId = placementTestId;

    this.fetch
      .fetch({
        url: `/grammar-placement-test-levels/${placementTestId}`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.grammarPlacementTestLevel = this.fetch.data;

          this.fetch
            .fetch({
              url: `/grammars/${this.grammarPlacementTestLevel.grammar}`,
            })
            .then(() => {
              if (this.fetch.data) {
                this.grammarPlacementTestLevel.grammar = this.fetch.data;
              }
            });
          this.fetch
            .fetch({
              url: `/placement-test-levels/${this.grammarPlacementTestLevel.placementTestLevel}`,
            })
            .then(() => {
              if (this.fetch.data) {
                this.grammarPlacementTestLevel.placementTestLevel = this.fetch.data;
              }
            });
        }
      });
  });

  handleShow = action((item) => {
    this.item = item;
    this.isOpen = true;
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.item = null;
    this.form.reset();
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    this.submit
      .fetch({
        method: 'post',
        url: `/grammar-placement-test-levels/${this.placementTestId}/items/${this.item.id}/draft`,
        body: {
          ...this.form.getValues(),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification('Drat successfully created', 'success');
          PlacementTestItemListService.load();
          this.handleClose();
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error to create draft', 'error');
        }
      });
  });
}

const createPlacementItemDraftService = new CreatePlacementItemDraftService();

export default createPlacementItemDraftService;
